import React, { useState, useRef, useEffect } from "react";
import HearhIcon from "../../styles/default/assets/icons/heart.svg";
import EmptyHeartIcon from "../../styles/default/assets/icons/heart-empty.svg";
import VetsIcon from "../../styles/default/assets/icons/dog-leash.svg";
import PharmacyIcon from "../../styles/default/assets/icons/pharmacy.png";
import HospitalIcon from "../../styles/default/assets/icons/hospital-32.svg";
import UrgentCareIcon from "../../styles/default/assets/icons/hospital-33.svg";

const facilityIcons = {
  vets: VetsIcon,
  urgentcare: UrgentCareIcon,
  hospitals: HospitalIcon,
  pharmacies: PharmacyIcon
}

const FacilityItem = ({
  components,
  keyToAdd,
  facilityData,
  addToFavorite,
  favoriteList = [],
  active,
  selected,
  onMouseEnter,
  onMouseLeave
 }) => {
  const [isFavorite, setFavorite] = useState(!!(favoriteList || []).find(facility => facilityData.data.id === facility.data.id));
  const { distance, placeType, data: { company, phone, address1, city, state, locationData, zip }} = facilityData;
  const el = useRef();

  useEffect(() => {
    if (selected && el.current) {
      el.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [selected]);

  const toggleFavorite = (facilityData) => {
    if (!isFavorite) {
      addToFavorite({
        favorite: true,
        meta: facilityData
      });
      favoriteList.push(facilityData);
    } else {
      addToFavorite({
        favorite: false,
        meta: facilityData
      });
      const index = favoriteList.findIndex(item => item.data.id === facilityData.data.id);
      index > -1 && favoriteList.splice(index, 1);
    }
    setFavorite(!isFavorite);
  }

  const addFavorieIcon = () => {
    return addToFavorite ? <components.Icon showIcon={true} src={isFavorite ? HearhIcon : EmptyHeartIcon} onClick={() => toggleFavorite(facilityData)} /> : null
  };

  return (
    <div
      ref={el}
      className={`facility-item-web-sdk facility-${keyToAdd} ${(active || selected) ? "active" : ""}`}
      onMouseEnter={() => onMouseEnter(facilityData)}
      onMouseLeave={() => onMouseLeave(facilityData)}
    >
      <div className='facility-info-web-sdk'>
        <div className='name-wrapper-web-sdk'>
          <div className='icon-wrapper-web-sdk'>
            <components.Icon
              showIcon={isFavorite}
              stylesObject={{
                width:           "21px",
                height:          "21px",
                backgroundColor: "#ffffff",
                marginBottom:    "-5px"
              }}
              src={facilityIcons[placeType]}
            />
          </div>
          <components.Label text={company} />
        </div>
        <components.Label params='address-wrapper-web-sdk' text={`${address1}, ${city}, ${locationData.state || state}, ${zip}`} />
        <div className='facility-phone-wrapper-web-sdk'>
          {
            phone ? (
              <>
                <components.Label params='phone-number-web-sdk' text={phone} />
                <span className='phone-link-wrapper-web-sdk'><components.PhoneLink label='Call' link={phone} /></span>
              </>
            ) : null
          }
        </div>
      </div>
      <div className='disance-favorite-wrapper-web-sdk'>
        <div className='disance-wrapper-web-sdk'>
          <components.Label text={`${distance.toFixed(2)} mi`} />
        </div>
        <div className='favorite-web-sdk'>
          {addToFavorite && addFavorieIcon()}
        </div>
      </div>
    </div>
  )
};

export default FacilityItem;
